const SvgPublicDeny = (props) => (
  <svg
    width={161}
    height={135}
    viewBox="0 0 161 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M72.6429 117.546C100.151 117.546 122.453 95.2449 122.453 67.6382C122.453 40.0315 100.053 17.73 72.6429 17.73C45.1345 17.73 22.833 40.0315 22.833 67.6382C22.833 95.2449 45.1345 117.546 72.6429 117.546Z"
      fill="#CDD9F0"
    />
    <path
      d="M29.5001 106.886C21.7474 117.304 41.6138 145.65 75.2897 119.485C108.966 93.3191 85.7074 57.2204 65.5987 53.5864C45.4901 49.9523 23.201 14.8227 51.3047 7.31228C79.4083 -0.198169 122.775 9.73501 98.3055 49.71C73.836 89.685 53.2428 97.9222 78.4392 105.19C98.5963 111.005 112.842 105.675 117.445 102.283"
      stroke="#5894FF"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeDasharray="4 4"
    />
    <g filter="url(#filter0_d_2310_3969)">
      <path
        d="M36.3393 94.1289C33.6042 72.9069 37.09 66.4947 40.6525 61.5369C42.6245 63.7982 44.0254 65.6954 44.0254 65.6954C43.6881 65.2796 45.6389 61.9048 45.8209 61.6193C47.72 58.0107 49.437 54.6876 51.6216 51.2611C63.064 34.2588 82.1376 22.925 101.596 16.6562C105.285 15.5945 108.974 14.5327 112.533 13.9903C114.403 13.5764 116.326 13.3962 118.196 12.9822C118.664 12.8787 123.495 12.5452 123.391 12.0776C116.987 29.6816 113.524 39.5222 115.983 49.5238C110.347 49.545 107.62 49.4128 101.649 46.8104C108.107 57.153 111.484 56.8962 111.484 56.8962C111.484 56.8962 104.328 72.2139 71.1501 85.1979C74.1589 89.9275 75.4832 90.3702 75.4832 90.3702C75.4832 90.3702 54.0199 101.988 39.5588 95.3783C36.3393 94.1289 36.3393 94.1289 36.3393 94.1289Z"
        fill="url(#paint0_linear_2310_3969)"
      />
    </g>
    <path
      d="M23.8007 117.26C35.6895 94.5181 50.1576 62.3763 78.8761 40.324C107.777 17.9862 127.341 9.97729 127.341 9.97729L124.767 12.7542C124.767 12.7542 96.1348 25.2227 71.412 52.0313C46.8713 78.5544 37.1902 101.298 30.4256 115.058C23.8007 117.26 23.8007 117.26 23.8007 117.26Z"
      fill="url(#paint1_linear_2310_3969)"
    />
    <path
      d="M20.2638 45.4244L22.9188 44.6241C23.1111 44.5683 23.1111 44.2892 22.9188 44.2333L20.2638 43.4331C20.1955 43.4145 20.1459 43.3649 20.1273 43.2966L19.3271 40.6478C19.2712 40.4555 18.9921 40.4555 18.9363 40.6478L18.136 43.2966C18.1174 43.3649 18.0678 43.4145 17.9996 43.4331L15.3508 44.2333C15.1585 44.2892 15.1585 44.5683 15.3508 44.6241L18.0058 45.4244C18.074 45.443 18.1236 45.4926 18.1422 45.5608L18.9425 48.2158C18.9983 48.4081 19.2774 48.4081 19.3333 48.2158L20.1335 45.5608C20.1459 45.4926 20.1955 45.443 20.2638 45.4244Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M69.5059 15.2607L72.2211 15.8238C72.4168 15.8665 72.5499 15.6211 72.4075 15.4803L70.4557 13.5106C70.4046 13.4617 70.3847 13.3944 70.4009 13.3256L70.961 10.6158C71.0036 10.4202 70.7583 10.287 70.6175 10.4294L68.6507 12.3757C68.6018 12.4268 68.5345 12.4468 68.4657 12.4306L65.7559 11.8705C65.5603 11.8278 65.4271 12.0732 65.5695 12.214L67.5213 14.1837C67.5724 14.2326 67.5924 14.2999 67.5762 14.3687L67.0131 17.0839C66.9704 17.2796 67.2158 17.4127 67.3566 17.2703L69.3263 15.3185C69.3698 15.2645 69.4371 15.2445 69.5059 15.2607Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M124.1 99.4443L126.175 97.6043C126.326 97.473 126.209 97.2196 126.011 97.2496L123.265 97.6369C123.195 97.6487 123.129 97.6243 123.084 97.5702L121.246 95.5016C121.115 95.3505 120.862 95.4675 120.892 95.6654L121.276 98.4056C121.288 98.4753 121.264 98.5412 121.21 98.5867L119.141 100.424C118.99 100.556 119.107 100.809 119.305 100.779L122.05 100.392C122.12 100.38 122.186 100.404 122.232 100.458L124.072 102.533C124.203 102.684 124.456 102.567 124.426 102.369L124.039 99.6229C124.022 99.5558 124.046 99.4898 124.1 99.4443Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M105.396 86.4799L107.719 85.7797C107.887 85.7308 107.887 85.4866 107.719 85.4378L105.396 84.7376C105.336 84.7213 105.293 84.6779 105.276 84.6182L104.576 82.3006C104.527 82.1324 104.283 82.1324 104.234 82.3006L103.534 84.6182C103.518 84.6779 103.474 84.7213 103.415 84.7376L101.097 85.4378C100.929 85.4866 100.929 85.7308 101.097 85.7797L103.42 86.4799C103.48 86.4961 103.523 86.5396 103.539 86.5993L104.24 88.9223C104.288 89.0905 104.533 89.0905 104.582 88.9223L105.282 86.5993C105.293 86.5396 105.336 86.4961 105.396 86.4799Z"
      fill="#6190FF"
    />
    <path
      d="M66.6326 111.322L68.9557 110.522C69.124 110.466 69.124 110.187 68.9557 110.131L66.6326 109.331C66.5729 109.313 66.5295 109.263 66.5132 109.195L65.813 106.546C65.7641 106.354 65.5199 106.354 65.471 106.546L64.7708 109.195C64.7545 109.263 64.7111 109.313 64.6514 109.331L62.3337 110.131C62.1655 110.187 62.1655 110.466 62.3337 110.522L64.6568 111.322C64.7166 111.341 64.76 111.391 64.7763 111.459L65.4765 114.114C65.5253 114.306 65.7696 114.306 65.8184 114.114L66.5186 111.459C66.5295 111.391 66.5729 111.341 66.6326 111.322Z"
      fill="#6190FF"
    />
    <path
      d="M33.7213 56.0502L35.3807 55.5501C35.5009 55.5153 35.5009 55.3408 35.3807 55.3059L33.7213 54.8058C33.6787 54.7942 33.6476 54.7632 33.636 54.7205L33.1359 53.0651C33.101 52.945 32.9265 52.945 32.8916 53.0651L32.3915 54.7205C32.3799 54.7632 32.3488 54.7942 32.3062 54.8058L30.6507 55.3059C30.5305 55.3408 30.5305 55.5153 30.6507 55.5501L32.3101 56.0502C32.3527 56.0619 32.3837 56.0929 32.3954 56.1355L32.8955 57.7948C32.9304 57.915 33.1049 57.915 33.1398 57.7948L33.6399 56.1355C33.6476 56.0929 33.6787 56.0619 33.7213 56.0502Z"
      fill="#6190FF"
    />
    <path
      d="M126.421 61.0224L128.08 60.5223C128.201 60.4874 128.201 60.313 128.08 60.2781L126.421 59.778C126.378 59.7664 126.347 59.7354 126.336 59.6927L125.836 58.0373C125.801 57.9172 125.626 57.9172 125.591 58.0373L125.091 59.6927C125.08 59.7354 125.049 59.7664 125.006 59.778L123.35 60.2781C123.23 60.313 123.23 60.4874 123.35 60.5223L125.01 61.0224C125.052 61.0341 125.083 61.0651 125.095 61.1077L125.595 62.767C125.63 62.8871 125.805 62.8871 125.839 62.767L126.34 61.1077C126.347 61.0651 126.378 61.0341 126.421 61.0224Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <path
      d="M45.986 32.9188L47.6453 32.4187C47.7655 32.3838 47.7655 32.2094 47.6453 32.1745L45.986 31.6744C45.9433 31.6628 45.9123 31.6317 45.9007 31.5891L45.4005 29.9337C45.3656 29.8136 45.1912 29.8136 45.1563 29.9337L44.6561 31.5891C44.6445 31.6317 44.6135 31.6628 44.5708 31.6744L42.9153 32.1745C42.7951 32.2094 42.7951 32.3838 42.9153 32.4187L44.5747 32.9188C44.6174 32.9305 44.6484 32.9615 44.66 33.0041L45.1601 34.6634C45.195 34.7835 45.3695 34.7835 45.4044 34.6634L45.9045 33.0041C45.9123 32.9615 45.9433 32.9305 45.986 32.9188Z"
      fill="#6190FF"
    />
    <path
      d="M21.2745 88.6415L22.9339 88.1414C23.0541 88.1065 23.0541 87.9321 22.9339 87.8972L21.2745 87.3971C21.2319 87.3854 21.2009 87.3544 21.1892 87.3118L20.6891 85.6564C20.6542 85.5362 20.4797 85.5362 20.4448 85.6564L19.9447 87.3118C19.9331 87.3544 19.9021 87.3854 19.8594 87.3971L18.2039 87.8972C18.0837 87.9321 18.0837 88.1065 18.2039 88.1414L19.8633 88.6415C19.9059 88.6531 19.937 88.6842 19.9486 88.7268L20.4487 90.386C20.4836 90.5062 20.6581 90.5062 20.693 90.386L21.1931 88.7268C21.2009 88.6842 21.2319 88.6531 21.2745 88.6415Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <defs>
      <filter
        id="filter0_d_2310_3969"
        x={13.3584}
        y={1.07764}
        width={132.034}
        height={129.334}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2310_3969"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2310_3969"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2310_3969"
        x1={72.7395}
        y1={21.0628}
        x2={88.1447}
        y2={90.6658}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--kula-dark-secondary-200, #FDFEFF)" />
        <stop
          offset={0.9964}
          stopColor="var(--kula-dark-secondary-50, #ECF0F5)"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2310_3969"
        x1={14.8467}
        y1={77.0678}
        x2={136.265}
        y2={50.1943}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3E83FF" />
        <stop offset={1} stopColor="var(--kula-dark-secondary-200, white)" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgPublicDeny;
